import { render, staticRenderFns } from "./AppDetailsModal.vue?vue&type=template&id=55aec82f&scoped=true"
import script from "./AppDetailsModal.vue?vue&type=script&lang=js"
export * from "./AppDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./AppDetailsModal.vue?vue&type=style&index=0&id=55aec82f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aec82f",
  null
  
)

export default component.exports